// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLazyload from 'vue-lazyload'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import store from './store'
import './config/global'
Vue.use(VueLazyload)
Vue.use(VueAxios, axios)
import 'assets/scss/style.css'
Vue.prototype.removePicker = function (){
	var elem = document.getElementsByClassName('picker')
	var _parentElement = elem[0].parentNode
	_parentElement.removeChild(elem[0])
}
new Vue({
  router,
  store,
  ...App
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js